import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconCircleReturned = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
            >
            <path
                fill={color}
                fillRule="evenodd"
                d="M7.847 13.878a.761.761 0 001.027 0 .646.646 0 000-.958l-1.182-1.102h1.275c.336 0 .664-.032.98-.094a3.43 3.43 0 012.904-1.8c.53-.713.842-1.58.842-2.513 0-2.436-2.115-4.408-4.726-4.408L4.727 3C4.324 3 4 3.302 4 3.678c0 .376.324.678.727.678h4.24c1.806 0 3.272 1.368 3.272 3.052s-1.466 3.051-3.272 3.051H7.692l1.182-1.102a.644.644 0 000-.957.764.764 0 00-1.027 0l-2.423 2.26a.644.644 0 000 .958l2.423 2.26zm7.106-2.11a2.685 2.685 0 00-1.936-.833c-.726 0-1.422.3-1.936.834a2.906 2.906 0 00-.801 2.013c0 .755.288 1.48.801 2.013.514.534 1.21.834 1.936.834s1.422-.3 1.936-.834a2.906 2.906 0 00.802-2.013c0-.755-.289-1.48-.802-2.013zm.447 4.492a3.304 3.304 0 01-2.383 1.026c-.893 0-1.75-.37-2.382-1.026a3.576 3.576 0 01-.987-2.478c0-.93.355-1.82.987-2.478a3.305 3.305 0 012.382-1.026c.894 0 1.75.37 2.383 1.026.631.657.986 1.549.986 2.478 0 .93-.355 1.82-.986 2.478zm-.896-3.585a.336.336 0 010 .464l-1.683 1.752a.306.306 0 01-.446 0l-.842-.876a.338.338 0 010-.464.306.306 0 01.446 0l.618.643 1.461-1.52a.307.307 0 01.446 0z"
                clipRule="evenodd"
            ></path>
        </svg>
    </div>
);

export default IconCircleReturned;